function initializeFeaturedCollectionSwipers() {
  console.log('Initializing featured collection swipers...');
  
  if (typeof Swiper === 'undefined') {
    console.error('Swiper is not loaded yet, retrying...');
    setTimeout(initializeFeaturedCollectionSwipers, 100);
    return;
  }
  
  const featuredCollectionSwipers = document.querySelectorAll('.featured-collection-swiper');
  console.log(`Found ${featuredCollectionSwipers.length} featured collection swiper(s)`);
  
  featuredCollectionSwipers.forEach((swiperElement, index) => {
    const desktopSlider = swiperElement.dataset.desktopSlider === 'true';
    const mobileSlider = swiperElement.dataset.mobileSlider === 'true';
    const columnsDesktop = parseInt(swiperElement.dataset.columnsDesktop) || 4;
    const columnsMobile = parseInt(swiperElement.dataset.columnsMobile) || 2;
    
    // Count actual slides
    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
    
    console.log(`Swiper ${index + 1} settings:`, {
      desktopSlider,
      mobileSlider,
      columnsDesktop,
      columnsMobile,
      slideCount
    });
    
    // If we have same or fewer slides than columns, just show all slides without peeking
    const desktopSlidesPerView = slideCount <= columnsDesktop ? slideCount : columnsDesktop + 0.5;
    const tabletSlidesPerView = slideCount <= 3 ? slideCount : Math.min(3, columnsDesktop) + 0.5;
    // Mobile: 2 full cards, flush against each other (matches the collection grid look)
    const mobileSlidesPerView = 2;
    
    try {
      const swiper = new Swiper(swiperElement, {
      grabCursor: true,
      slidesPerView: mobileSlidesPerView,
      spaceBetween: 0,
      navigation: {
        nextEl: swiperElement.querySelector('.swiper-button-next'),
        prevEl: swiperElement.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: tabletSlidesPerView,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: tabletSlidesPerView,
          spaceBetween: 10,
        },
        1100: {
          slidesPerView: desktopSlidesPerView,
          spaceBetween: 10,
        },
      },
      });
      
      console.log(`✓ Swiper ${index + 1} initialized successfully`);
      
      // Add class to show the swiper with fade-in effect
      swiperElement.classList.add('swiper-initialized');
      
      // Process products after Swiper initializes
      if (window.productCardDataManager) {
        const products = swiperElement.querySelectorAll('.product-item');
        if (products.length > 0) {
          console.log(`Processing ${products.length} featured collection products...`);
          window.productCardDataManager.processProductCards(Array.from(products));
        }
      }

      // Remove cards with no price / not available at the current location so the
      // carousel doesn't leave gaps or stale slides, then refresh Swiper's layout.
      const removeUnavailableSlides = () => {
        const unavailable = swiperElement.querySelectorAll('.swiper-slide.location-unavailable');
        if (unavailable.length === 0) return;
        unavailable.forEach((slide) => slide.remove());
        console.log(`Removed ${unavailable.length} unavailable slide(s) from featured collection`);
        swiper.update();
        if (swiper.navigation) swiper.navigation.update();
      };
      removeUnavailableSlides();

      // Re-run cleanup when the picking location changes (cards get re-processed).
      document.addEventListener('locationChanged', () => {
        setTimeout(removeUnavailableSlides, 150);
      });
    } catch (error) {
      console.error(`Failed to initialize Swiper ${index + 1}:`, error);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFeaturedCollectionSwipers);
} else {
  // DOM is already loaded
  initializeFeaturedCollectionSwipers();
}
